import { apiUrl } from '../utils/api-url';

export interface TemplateManifestEntry {
  templateId: string;
  title: string;
  cafPhase: string;
  engagementType?: string | null;
  auditControls?: string[] | null;
}

export async function listTemplates(token: string): Promise<TemplateManifestEntry[]> {
  const res = await fetch(apiUrl('/api/templates'), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to list templates: ${res.status}`);
  return res.json();
}
